<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="learning-path-deadline-series"
            :items="tableData"
            :fields="deadlineSeriesFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-lp-dead-line-series"
                    v-b-modal="'create-lp-deadline-series-modal'"
                    type="button"
                    label="create new lp deadline series"
                    variant="primary">
                    {{ $t('learning_path.add_class') }}
                </b-button>
            </template>

            <template v-slot:cell(lasGroups)="data">
                <div
                    class="las-groups"
                    v-if="data.item.lasGroups.split(',').length <= 3">
                    {{ data.item.lasGroups }}
                </div>

                <div
                    class="las-groups-extended"
                    v-else>
                    {{ data.item.lasGroups.split(',').slice(0, 2).join(', ') }}

                    <b-button
                        class="btn-las-group-info"
                        v-b-popover.hover.focus="data.item.lasGroups"
                        variant="primary-icon-only">
                        <i class="fad fa-info-circle icon"></i>
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(lasMainGroups)="data">
                <div
                    class="las-groups"
                    v-if="data.item.lasMainGroups.split(',').length <= 3">
                    {{ data.item.lasMainGroups }}
                </div>

                <div
                    class="las-main-groups-extended"
                    v-else>
                    {{ data.item.lasMainGroups.split(',').slice(0, 2).join(', ') }}

                    <b-button
                        class="btn-las-main-group-info"
                        v-b-popover.hover.focus="data.item.lasMainGroups"
                        variant="primary-icon-only">
                        <i class="fad fa-info-circle icon"></i>
                    </b-button>
                </div>
            </template>
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-lp-deadline-series"
                        v-b-tooltip.hoover
                        variant="primary-icon-only"
                        :title="$t('common.open')"
                        @click="openDeadlineSeries(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-lp-deadline-series btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="openEditDeadlineSeries(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-lp-deadline-series"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeDeadlineSeries(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-create-learning-path-deadline-series-modal
            :las-groups-in="this.lasGroupsIn"
            :las-main-groups-in="this.lasMainGroupsIn"
            @createDeadlineSeries="createDeadlineSeries($event)"
            ref="create-lp-deadline-series-modal">
        </design-2021-create-learning-path-deadline-series-modal>
        <design-2021-edit-learning-path-deadline-series-modal
            :las-groups-in="this.lasGroupsIn"
            :las-main-groups-in="this.lasMainGroupsIn"
            @updateDeadlineSeries="updateDeadlineSeries($event)"
            ref="edit-lp-deadline-series-modal">
        </design-2021-edit-learning-path-deadline-series-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-deadline-series-index-tab-component',
    props: ['lpDeadlineSeriesIn', 'lasGroupsIn', 'lasMainGroupsIn'],
    data() {
        return {
            lpDeadlineSeries: this.lpDeadlineSeriesIn,
            deadlineSeriesFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'lasGroups',
                    label: this.$t('learning_path.lesson_groups'),
                },
                {
                    key: 'lasMainGroups',
                    label: this.$t('learning_path.main_groups'),
                },

                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.lpDeadlineSeries.map((series) => {
                return {
                    id: series.id,
                    name: series.name,
                    lasGroups: series.las_groups.map((lasGroup) => lasGroup.name).join(', '),
                    lasMainGroups: series.las_main_groups.map((lasMainGroup) => lasMainGroup.name).join(', '),
                };
            });
        },
    },
    methods: {
        createDeadlineSeries(data) {
            this.lpDeadlineSeries.push(data);
            this.alert.success();
        },
        openEditDeadlineSeries(seriesId) {
            const series = this.lpDeadlineSeries.find((series) => series.id === seriesId);
            this.$refs['edit-lp-deadline-series-modal'].show(series);
        },
        updateDeadlineSeries(data) {
            this.lpDeadlineSeries = this.lpDeadlineSeries.map((series) => {
                if (series.id === data.id) {
                    const newSeries = { ...series, ...data };
                    return newSeries;
                } else {
                    return series;
                }
            });
            this.alert.success();
        },
        removeDeadlineSeries(id) {
            this.alert
                .confirm(
                    this.$t('learning_path.delete_deadline_series'),
                    this.$t('learning_path.are_you_sure_you_want_to_delete_this_deadline_series'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.removeLpDeadlineSeries(id)).then(
                        (response) => {
                            this.lpDeadlineSeries = this.lpDeadlineSeries.filter((item) => item.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        openDeadlineSeries(id) {
            window.location.href = this.routes.LpDeadlineSeries(id);
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .btn {
        &:before {
            margin-right: 0;
        }
    }
}

.btn-las-group-info,
.btn-las-main-group-info {
    margin-left: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
